import React, { lazy, Suspense } from 'react';
import { LatteSpinner } from '../../components/common';
import { useMediaQuery } from '../../hooks/useMediaQuery';

// Lazy loading으로 번들 크기 최적화
const DesktopConsultingPage = lazy(() => import('./DesktopConsultingPage'));
const MobileConsultingPage = lazy(() => import('./MobileConsultingPage'));

const ConsultingPage = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
  
  // 로딩 화면
  const LoadingFallback = () => (
    <div className="page-container flex-col flex-center p-4">
      <div className="text-center">
        <LatteSpinner size="lg" className="mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">페이지를 불러오는 중...</h2>
      </div>
    </div>
  );

  return (
    <Suspense fallback={<LoadingFallback />}>
      {(isMobile || isTablet) ? (
        <MobileConsultingPage />
      ) : (
        <DesktopConsultingPage />
      )}
    </Suspense>
  );
};

export default ConsultingPage;
